import BaseEntity from 'client/components/core/BaseEntity/BaseEntityNew'
import { FieldInterface } from 'common/types/entities/field-interface'
import React from 'react'
import { BaseEditorField } from 'src/editor/shared/entities/base-editor-field'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

interface FieldNewProps {
  entity: FieldInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
  isSaveAllowed?: boolean
  isRemoveAllowed?: boolean
  isCopyAllowed?: boolean
  dropBoxAllowedEntityIds?: EntityIdType[]
}

const FieldNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
  isRemoveAllowed = true,
  isSaveAllowed = true,
  isCopyAllowed = true,
  dropBoxAllowedEntityIds,
}: FieldNewProps) => {
  return (
    <BaseEntity
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      isRemoveAllowed={isRemoveAllowed}
      isSaveAllowed={isSaveAllowed}
      isCopyAllowed={isCopyAllowed}
      dropBoxAllowedEntityIds={dropBoxAllowedEntityIds}
    >
      <BaseEditorField entity={entity} />
    </BaseEntity>
  )
}

export default FieldNew
